<template>
  <div class="accordion-container mt-4">
    <p class="accent">{{ t('label_chatroom_settings') }}</p>

    <Info2Column :title="t('label_interpretation_chatroom_name')">
      <InputWithMessage v-model="form.title" :placeholder="$t('alert_enter_interpretation_chatroom_name')">
      </InputWithMessage>
    </Info2Column>

    <Info2Column :title="t('label_chatroom_description')">
      <TextAreaWithMessage v-model="form.description" :placeholder="$t('alert_enter_chatroom_description')" />
    </Info2Column>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import InputWithMessage from '@/components/shared/base/InputWithMessage.vue';
import TextAreaWithMessage from '@/components/shared/base/TextAreaWithMessage.vue';
import Info2Column from '@/components/shared/composite/Info2Column.vue';
import { ChatCreateForm } from '@/types/components';
import { DEFAULT_CHAT_CREATE_FORM } from '@/utils/constants/chat';

const { t } = useI18n();

const form = defineModel<ChatCreateForm>('form', {
  default: DEFAULT_CHAT_CREATE_FORM,
});
</script>

<style lang="scss" scoped>
.error-comment {
  color: var(--color-red);
  margin-top: 5px;
}
</style>
